import {connect} from 'react-redux';
import './ReportHistoryListWithShare.scss';
import ReportHistoryListWithShare from './ReportHistoryListWithShare.lazy';

const mapStateToProps = (state, ownProps) => {

  return {
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const ReportHistoryListWithShareContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ReportHistoryListWithShare);

export { ReportHistoryListWithShareContainer, ReportHistoryListWithShare };
export default ReportHistoryListWithShareContainer;